import { store } from './../store'

export const VIEW_APPEND  = 'VIEW_APPEND'
export const VIEW_REMOVE  = 'VIEW_REMOVE'

export const viewAppend = (path, container = null) => {
  store.dispatch({type: VIEW_APPEND, payload: {view: path, container}})
}
export const viewRemove = (path, container = null) => {
  store.dispatch({type: VIEW_REMOVE, payload: {view: path, container}})
}